import { PageState } from "../../components/page-state.js";

/**
 * Where setup would have been, for someone who may not add a brand
 * (DESIGN.md, "People and access"). Either they have no brands yet, or they
 * asked to add one; both are answered by an owner or admin, so the page says
 * who to ask rather than offering a wizard the server would refuse.
 */
export function NoBrandsYet({
  workspaceName,
  asked,
  onBack,
  onSignOut,
}: {
  readonly workspaceName: string;
  readonly asked: boolean;
  readonly onBack: () => void;
  readonly onSignOut: () => void;
}) {
  if (asked) {
    return (
      <PageState
        title="Adding brands is switched off for you"
        actions={
          <button type="button" className="button-primary" onClick={onBack}>
            Back
          </button>
        }
      >
        An owner or admin of {workspaceName} decides who adds brands. Ask one of them to
        switch on Add brands for you, or to add the brand themselves.
      </PageState>
    );
  }
  return (
    <PageState
      title="No brands for you yet"
      actions={
        <>
          <button
            type="button"
            className="button-primary"
            onClick={() => {
              window.location.reload();
            }}
          >
            Check again
          </button>
          <button type="button" className="button-secondary" onClick={onSignOut}>
            Sign out
          </button>
        </>
      }
    >
      An owner or admin of {workspaceName} chooses which brands you see. Ask them to give
      you one; it appears here the moment they do.
    </PageState>
  );
}
